import EmailLogsTable from "./page/EmailLogsTable"

const EmailLogs:React.FC =()=>{
    return(
        <>
        <EmailLogsTable/>
        </>
    )
};
export default EmailLogs